import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API_BASE,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add auth token to requests if available
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('asg_admin_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Public API
export const getVehicles = (params) => api.get('/vehicles', { params });
export const getVehicle = (id) => api.get(`/vehicles/${id}`);
export const getSimilarVehicles = (id) => api.get(`/vehicles/${id}/similar`);
export const getVehicleFilters = () => api.get('/vehicles/filters');
export const getPublicSettings = () => api.get('/settings/public');
export const createLead = (data) => api.post('/leads', data);
export const trackEvent = (data) => api.post('/events', data);

// Auth
export const adminLogin = (data) => api.post('/admin/login', data);

// Admin API
export const adminGetVehicles = () => api.get('/admin/vehicles');
export const adminUpdateVehicle = (id, data) => api.patch(`/admin/vehicles/${id}`, data);
export const adminGetSettings = () => api.get('/admin/settings');
export const adminUpdateSetting = (key, value) => api.put(`/admin/settings/${key}`, { value });
export const adminGetLeads = (status) => api.get('/admin/leads', { params: { status } });
export const adminUpdateLead = (id, status) => api.patch(`/admin/leads/${id}`, { status });
export const adminGetSyncLogs = () => api.get('/admin/sync-logs');
export const adminTriggerSync = () => api.post('/admin/sync');
export const adminGetSyncStatus = () => api.get('/admin/sync-status');
export const adminGetSyncConfig = () => api.get('/admin/sync-config');
export const adminTestSyncConfig = () => api.post('/admin/sync-config/test');
export const adminDiagnoseScraping = () => api.post('/admin/scrape-diagnose', {}, { timeout: 120000 });
export const adminGetStats = () => api.get('/admin/stats');
export const adminCreateVehicle = (data) => api.post('/admin/vehicles', data);
export const adminDeleteVehicle = (id) => api.delete(`/admin/vehicles/${id}`);
export const adminChangePassword = (data) => api.post('/admin/change-password', data);
export const adminUploadImage = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/admin/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export default api;
